<ng-container *transloco="let t">
    <div class="flex flex-row">

        <div class="basis-0 md:basis-1/6"></div>
        <div class="basis-full md:basis-4/6 px-4 md:px-0 min-w-0">
            <div class="flex flex-row items-center">
                <hr class="w-24 bg-primary">
                <p class="text-primary pl-4">{{t(pretitle)}}</p>
            </div>

            <h1 class="text-2xl sm:text-3xl md:text-4xl font-medium pl-4 md:pl-8">{{t(title)}}</h1>
            <mat-accordion class="mt-8" [displayMode]="'flat'">
                <mat-expansion-panel *ngFor="let faq of points;  trackBy: trackByFn">
                    <mat-expansion-panel-header [collapsedHeight]="'75px'">
                        <mat-panel-title class="font-medium leading-tight">
                            {{t(faq.question)}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="mt-4 text-primary">{{t(faq.answer)}}</div>
                </mat-expansion-panel>
            </mat-accordion>
            <div class="flex flex-row justify-end mt-4">
                <a class="cursor-pointer underline text-primary text-lg mr-4 md:mr-0" [href]="landing.href('faq')">{{t('button-show-all')}}</a>
            </div>
        </div>
        <div class="basis-0 sm:basis-0 md:basis-1/6 lg:basis-1/6"></div>
    </div>
</ng-container>
